import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { rootCssSet } from "../../utils/helpers/common";

const initialState = {
  sendInviteDialog: false,
  agentFilterDialog: false,
  agentListReset: false,
  paymentInfoFilter: false,
  paymentInfoListReset: false,
  agentInfoReset:false
};

export const agentSlice = createSlice({
  name: "agent",
  initialState,
  reducers: {
    setInviteDialog: (state) => {
      state.sendInviteDialog = !state.sendInviteDialog;
    },

    setAgentFilterDialog: (state) => {
      state.agentFilterDialog = !state.agentFilterDialog;
      rootCssSet();
    },

    setAgentInfoReset: (state) => {
      state.agentInfoReset = !state.agentInfoReset;
    },

    setAgentListReset: (state) => {
      state.agentListReset = !state.agentListReset;
    },

    setPaymentInfoFilter: (state) => {
      state.paymentInfoFilter = !state.paymentInfoFilter;
    },

    setPaymentInfoListReset: (state) => {
      state.paymentInfoListReset = !state.paymentInfoListReset;
    },
  },
});

export const agentAction = agentSlice.actions;
export const agentReducer = agentSlice.reducer;
